<template>
  <div class="editserviceinfo">
    <div class="service_tip flex">
      <span>服务项目</span>
      <span class="flex_center">
        已选{{count}}项&nbsp;
        <van-icon name="arrow-down" size="13" />
      </span>
    </div>

    <div class="service_box">
      <van-checkbox-group v-model="result" :change="check_change()">
        <van-checkbox :name="item.id" v-for="(item,index) in tech_service" :key="index" checked>{{item.title}}</van-checkbox>
      </van-checkbox-group>
    </div>

    <div class="van-cell van-field van-field--error">
        <div class="van-cell__title van-field__label">
          <span>每日服务时间</span>
        </div>
        <div class="van-cell__value">
          <div class="van-field__body fr">
            <span class="" @click="sel_evdaystartime"> {{evdaystartime?evdaystartime:'开始时间'}}</span>
            <span class="" @click="sel_evdayendtime"> &nbsp;-&nbsp;{{evdayendtime?evdayendtime:'结束时间'}}</span>
          </div>
        </div>
      </div>

    <div class="btn_box">
      <button class="save_btn" @click="save">保存</button>
    </div>

    <van-popup v-model="evdaystartimebox" position="bottom">
      <van-datetime-picker
        v-model="evdaystartime"
        type="time"
        :min-hour="0"
        :max-hour="23"
        :formatter="formatter"
        @confirm="cf_evdaystarttime"
        @cancel="_cancel"
      />
    </van-popup>

    <van-popup v-model="evdayendtimebox" position="bottom">
      <van-datetime-picker
        v-model="evdayendtime"
        type="time"
        :min-hour="0"
        :max-hour="24"
        :formatter="formatter"
        @confirm="cf_evdayendttime"
        @cancel="_cancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "editserviceinfo",
  components: {},
  data() {
    return {
      result: [],
      count: 0,
      worktimebox: false,
      minDate: new Date('1970/01'),
      maxDate: new Date(),
      worktime: '',
      evdaystartime: '',
      evdaystartimebox: false,
      evdayendtime: '',
      evdayendtimebox: false,
      tech_service:[]
    };
  },
  created() {
    this.count = this.result.length;
    this.init();

  },
  methods: {
    init(){
      this.get_tech_service();
    },
    get_tech_service(){
      this.axios({
        url: this.api.tech.get_tech_service,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech_service = res.service;
          this.tech_id = res.tech.id;
          this.evdaystartime = res.tech.working_starttime;
          this.evdayendtime = res.tech.working_endtime;
          this.result = res.tect_service_ids;
        }
      });
    },
    save(){
      this.axios({
        url: this.api.tech.update_tech_service,
        data: {tech_id:this.tech_id,result:this.result,working_starttime:this.evdaystartime,working_endtime:this.evdayendtime}
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success"
          });
        }else{
          this.$toast({
            message: res.error,
          });
        }
      });
    },
    check_change() {
      this.count = this.result.length;
    },
    sel_worktime(){
      this.worktimebox = true;
    },
    _cancel(){
      this.worktimebox = false;
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    cf_worktime(value){
      var date = value.getFullYear() + '年' + (value.getMonth() + 1) + '月';
      this.worktime = date;
      this.worktimebox = false;
    },
    sel_evdaystartime(){
      this.evdaystartimebox = true;
    },
    cf_evdaystarttime(value){
      this.evdaystartime = value;
      this.evdaystartimebox = false;
    },
    sel_evdayendtime(){
      this.evdayendtimebox = true;
    },
    cf_evdayendttime(value){
      this.evdayendtime = value;
      this.evdayendtimebox = false;
    }
  }
};
</script>
<style scoped>
.btn_box {
  text-align: center;
  background-color:#F4F5F6;
}
.save_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 4rem;
  margin-top: 3.5rem;
  font-size: 0.9rem;
}
.editserviceinfo {
  background-color: white;
}
.service_tip {
  font-size: 0.75rem;
  color: #636363;
  padding: 1rem 2rem;
}
.service_tip span:last-child {
  color: #adadad;
}
.service_box {
  padding: 0.5rem 2rem;
  border: 1px solid #eee;
  border-left: none;
  border-right: none;
  font-size: 0.7rem;
  color: #6e6d6d;
}
.van-checkbox__icon {
  font-size: 0.7rem !important;
}
.van-checkbox {
  padding: 0.1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/perData/editserviceinfo.vue